import React, { memo } from 'react';
import './styles.css';

/**
 * くるくる部分
 */
interface CircleTicketProps {
    upperHalfColor?: string;
    lowerHalfColor?: string;
    rotationColor?: string;
    circleSize?: number;
}

const CircleTicket = memo(
    ({
        upperHalfColor = '#FFFFFF77',
        lowerHalfColor = '#FFFFFF77',
        rotationColor = '#0096E2',
        circleSize,
    }: CircleTicketProps) => {
        const size = 360; // 指定する必要があればこれを使う。360にしたのは計算が楽になるように。
        const strokeWidth = size * 0.1;
        const radius = (size - strokeWidth) / 2;
        const center = { x: size / 2, y: size / 2 };
        const angleStep = 30;
        const grooveAngle = 4;

        const getPath = (startAngle: number, endAngle: number) => {
            const startX = center.x + radius * Math.cos((startAngle * Math.PI) / 180);
            const startY = center.y + radius * Math.sin((startAngle * Math.PI) / 180);
            const endX = center.x + radius * Math.cos((endAngle * Math.PI) / 180);
            const endY = center.y + radius * Math.sin((endAngle * Math.PI) / 180);
            return `M${startX},${startY} A${radius},${radius} 0 0 1 ${endX},${endY}`;
        };

        const arcs = [];
        for (let i = 0; i < 12; i += 1) {
            arcs.push(
                <path
                    key={i}
                    d={getPath(angleStep * i + grooveAngle / 2, angleStep * (i + 1) - grooveAngle / 2)}
                    stroke={i < 6 ? lowerHalfColor : upperHalfColor}
                    strokeWidth={strokeWidth}
                    fill="none"
                />,
            );
        }

        const circlePath = `M ${center.x - radius} ${center.y} A${radius} ${radius} 0 0 1 ${center.x + radius},${
            center.y
        } A${radius} ${radius} 0 0 1 ${center.x - radius},${center.y}`;

        return (
            <div className="circle">
                <svg viewBox={`0 0 ${size} ${size}`} width={`${circleSize}px`} height={`${circleSize}px`}>
                    {arcs}
                    <path id={'circle'} stroke={'#FFFFFF00'} fill="none" />
                    <circle r={strokeWidth / 2} fill={rotationColor}>
                        <animateMotion dur="1s" repeatCount="indefinite" path={circlePath} />
                    </circle>
                </svg>
            </div>
        );
    },
);

export default CircleTicket;
